import React, { useContext, useState } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import MyContext from "../../../../context/MyContext";
import "../../../../assets/css/seller/Auth/SellerAuthform.css";

// ── Pakistan Cities — Customer/Delivery register jaisi hi list,
// consistency ke liye ──
const PAKISTAN_CITIES = [
  "Abbottabad", "Attock", "Bahawalpur", "Bahawalnagar", "Burewala", "Chakwal",
  "Chiniot", "Chishtian", "Daska", "Dera Ghazi Khan", "Dera Ismail Khan",
  "Faisalabad", "Ghotki", "Gujranwala", "Gujrat", "Hafizabad", "Haripur",
  "Hyderabad", "Islamabad", "Jacobabad", "Jhelum", "Kamoke", "Karachi",
  "Kasur", "Khanewal", "Khushab", "Khuzdar", "Lahore", "Larkana", "Layyah",
  "Lodhran", "Mailsi", "Mansehra", "Mardan", "Mianwali", "Mirpur Khas",
  "Multan", "Muridke", "Muzaffarabad", "Muzaffargarh", "Narowal", "Nawabshah",
  "Nowshera", "Okara", "Pakpattan", "Peshawar", "Quetta", "Rahim Yar Khan",
  "Rawalpindi", "Sadiqabad", "Sahiwal", "Sargodha", "Sheikhupura", "Sialkot",
  "Sukkur", "Swabi", "Swat", "Toba Tek Singh", "Vehari", "Wah Cantonment",
  "Wazirabad",
].sort();

const errBorder = { borderColor: "#dc3545" };
const errText = { color: "#dc3545", fontSize: 12, marginTop: 4, marginBottom: 8 };

const SellerRegister = () => {
  const [showPassword, setShowPassword] = useState(false);

  // states
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [city, setCity] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { baseUrl, regExpChecker } = useContext(MyContext);
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [resending, setResending] = useState(false);

  // ── NEW: field-level errors — DeliveryRegister.jsx jaisa pattern,
  // separate useState per field taake har field ka apna error alag
  // se, saath saath dikh sake (sirf ek ke baad ek nahi) ──
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [cityError, setCityError] = useState("");

  // ── NEW: pura form validate karta hai, saari fields ek saath
  // check karke — DeliveryRegister.jsx wala pattern. Ab koi field
  // pehle wali field ke error ki wajah se "chupti" nahi ──
  const validateForm = () => {
    let valid = true;

    const nameErr = regExpChecker("username", name);
    if (!name) {
      setNameError("Full name is required");
      valid = false;
    } else if (nameErr) {
      setNameError(nameErr);
      valid = false;
    } else setNameError("");

    const emailErr = regExpChecker("email", email);
    if (!email) {
      setEmailError("Email is required");
      valid = false;
    } else if (emailErr) {
      setEmailError(emailErr);
      valid = false;
    } else setEmailError("");

    if (!city) {
      setCityError("City is required");
      valid = false;
    } else setCityError("");

    const passErr = regExpChecker("password", password);
    if (!password) {
      setPasswordError("Password is required");
      valid = false;
    } else if (passErr) {
      setPasswordError(passErr);
      valid = false;
    } else setPasswordError("");

    return valid;
  };

  const sendRegisterOtp = ({ isResend = false } = {}) => {
    if (!isResend && !validateForm()) return;

    setErrorMessage("");
    isResend ? setResending(true) : setLoading(true);

    const formdata = new FormData();
    formdata.append("name", name);
    formdata.append("email", email);
    formdata.append("password", password);
    formdata.append("city", city);

    axios
      .post(`${baseUrl}/seller/auth/sendRegisterOtp`, formdata)
      .then((response) => {
        isResend ? setResending(false) : setLoading(false);
        const data = response.data;
        if (data.success) {
          Swal.fire(
            "Sent!",
            isResend
              ? "A new verification code has been sent to your email."
              : "A verification code has been sent to your email.",
            "success"
          );
          setStep(2);
        } else {
          setErrorMessage(data.message || "Something went wrong. Please try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        isResend ? setResending(false) : setLoading(false);
        setErrorMessage("Something went wrong. Please try again.");
      });
  };

  const resendOtp = () => {
    sendRegisterOtp({ isResend: true });
  };

  const verifyRegisterOtp = () => {
    if (!otp) {
      setOtpError("Please enter the code sent to your email");
      return;
    }

    setOtpError("");
    setErrorMessage("");
    setLoading(true);

    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("otp", otp);

    axios
      .post(`${baseUrl}/seller/auth/verifyRegisterOtp`, formdata)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          console.log("Registration successful", data);
          localStorage.setItem("sellerEmail", email);
          localStorage.setItem("sellerPassword", password);
          localStorage.setItem("sellerVerified", "false");
          setLoading(false);
          navigate("/seller/login");
        } else {
          setLoading(false);
          setOtpError(data.message || "Invalid OTP. Please try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        setOtpError("Something went wrong. Please try again.");
      });
  };

  const submitRegisterForm = (event) => {
    event.preventDefault();
    if (step === 1) {
      sendRegisterOtp();
    } else {
      verifyRegisterOtp();
    }
  };

  return (
    <div className="minimal-auth-wrapper">
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          />
          <p style={{ marginTop: "15px", fontSize: "18px" }}>
            {step === 1 ? "Sending verification code..." : "Verifying..."}
          </p>
        </div>
      ) : (
        <div className="minimal-auth-container">
          <div className="minimal-auth-card">
            {/* Logo */}
            <div className="auth-logo">
              {/* <div className="logo-icon">🌾</div> */}
            </div>

            {/* Header */}
            <div className="auth-header">
              <h1 className="auth-title">Create Seller Account</h1>
              <p className="auth-subtitle">
                {step === 1
                  ? "Enter your details below — we'll email you a code to verify it's really you."
                  : `We've sent a 6-digit code to ${email}.`}
              </p>
              <p className="auth-subtitle">
                Already have an account?{" "}
                <Link to="/seller/login" className="auth-link">
                  Login here
                </Link>
              </p>
            </div>

            <Form onSubmit={submitRegisterForm} className="minimal-auth-form">
              {step === 1 ? (
                <>
                  {/* Full Name */}
                  <div className="authform-group-minimal">
                    <Form.Control
                      type="text"
                      placeholder="Full name"
                      value={name}
                      style={nameError ? errBorder : undefined}
                      onChange={(event) => {
                        setName(event.target.value);
                        setNameError(event.target.value ? (regExpChecker("username", event.target.value) || "") : "Full name is required");
                      }}
                      className="minimal-input"
                    />
                    {nameError && <p style={errText}>{nameError}</p>}
                  </div>

                  {/* Email */}
                  <div className="authform-group-minimal">
                    <Form.Control
                      type="email"
                      placeholder="email"
                      value={email}
                      style={emailError ? errBorder : undefined}
                      onChange={(event) => {
                        setEmail(event.target.value);
                        setEmailError(event.target.value ? (regExpChecker("email", event.target.value) || "") : "Email is required");
                      }}
                      className="minimal-input"
                    />
                    {emailError && <p style={errText}>{emailError}</p>}
                  </div>

                  {/* City */}
                  <div className="authform-group-minimal">
                    <Form.Select
                      value={city}
                      style={cityError ? errBorder : undefined}
                      onChange={(event) => {
                        setCity(event.target.value);
                        setCityError(event.target.value ? "" : "City is required");
                      }}
                      className="minimal-input"
                    >
                      <option value="">Select your city</option>
                      {PAKISTAN_CITIES.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </Form.Select>
                    {cityError && <p style={errText}>{cityError}</p>}
                  </div>

                  {/* Password */}
                  <div className="authform-group-minimal">
                    <div className="password-input-wrapper">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        style={passwordError ? errBorder : undefined}
                        onChange={(event) => {
                          setPassword(event.target.value);
                          if (!event.target.value) setPasswordError("Password is required");
                          else setPasswordError(regExpChecker("password", event.target.value) || "");
                        }}
                        className="minimal-input"
                      />
                      <button
                        type="button"
                        className="password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    {passwordError && <p style={errText}>{passwordError}</p>}
                  </div>

                  {/* Error Message */}
                  {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

                  {/* Submit */}
                  <Button type="submit" className="minimal-submit-btn" disabled={loading}>
                    Send Verification Code
                  </Button>

                  <p className="terms-text">
                    By registering, you agree to our{" "}
                    <a href="#terms" className="terms-link">
                      Terms of Service
                    </a>{" "}
                    and{" "}
                    <a href="#privacy" className="terms-link">
                      Privacy Policy
                    </a>
                  </p>
                </>
              ) : (
                <>
                  {/* OTP */}
                  <div className="authform-group-minimal">
                    <Form.Control
                      type="text"
                      placeholder="6-digit code"
                      value={otp}
                      style={otpError ? errBorder : undefined}
                      onChange={(event) => setOtp(event.target.value)}
                      className="minimal-input"
                    />
                    {otpError && <p style={errText}>{otpError}</p>}
                  </div>

                  {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

                  {/* Submit */}
                  <Button type="submit" className="minimal-submit-btn" disabled={loading}>
                    Verify &amp; Create Account
                  </Button>

                  <p className="terms-text">
                    Didn't receive the code?{" "}
                    <span
                      onClick={() => !resending && resendOtp()}
                      style={{
                        color: "#097d43",
                        fontWeight: 600,
                        cursor: resending ? "default" : "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      {resending ? "Resending..." : "Resend"}
                    </span>
                  </p>

                  <button
                    type="button"
                    onClick={() => {
                      setStep(1);
                      setOtp("");
                      setOtpError("");
                      setErrorMessage("");
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#097d43",
                      marginTop: "0.25rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    ← Edit details
                  </button>
                </>
              )}
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerRegister;
